export interface Article {
  id: string;
  title: string;
  excerpt: string;
  category: string;
  tag: string;
  date: string;
  readTime: string;
  likes: number;
  image: string;
}

export const categories: string[] = [
  "剧情速览",
  "结局考据",
  "人物档案",
  "伏笔盘点",
  "读者圆桌",
  "创作手记",
];

export const articles: Article[] = [
  {
    id: "guide-open",
    title: "开篇三话导读：一场误会引发的日常",
    excerpt: "很多读者都是从一场「误会」入坑的。本文带你从第一话开始，梳理阿浩、小雨与嘿咻猫咪是怎么在同一间小小的电台里相遇的。",
    category: "剧情速览",
    tag: "导读",
    date: "2026-08-02",
    readTime: "6 分钟",
    likes: 328,
    image: "https://readdy.ai/api/search-image?query=Stylized%20editorial%20manga%20illustration%20of%20a%20cozy%20retro%20radio%20studio%20interior%20with%20warm%20desk%20lamp%20and%20scattered%20paper%20notes%2C%20warm%20vermilion%20and%20cream%20ink%20palette%20with%20halftone%20dots%20and%20soft%20brush%20texture%2C%20vintage%20comic%20panel%2C%20inviting%20slice-of-life%20mood%2C%20high%20detail&width=900&height=600&seq=art-open&orientation=landscape",
  },
  {
    id: "mid-line",
    title: "中段主线解析：阿浩与小雨的十年之约",
    excerpt: "「十年之约」并非一句空话。中段剧情把这对青梅竹马的约定层层展开，也悄悄埋下了贯穿到结局的那根线。",
    category: "剧情速览",
    tag: "主线",
    date: "2026-08-09",
    readTime: "8 分钟",
    likes: 512,
    image: "https://readdy.ai/api/search-image?query=Stylized%20editorial%20manga%20illustration%20of%20two%20silhouettes%20walking%20on%20a%20warm%20evening%20street%20under%20string%20lights%2C%20warm%20vermilion%20and%20amber%20ink%20palette%20with%20halftone%20dots%2C%20vintage%20comic%20panel%2C%20nostalgic%20hopeful%20mood%2C%20high%20detail&width=900&height=600&seq=art-mid&orientation=landscape",
  },
  {
    id: "ending-deep",
    title: "大结局深度解析：那句没说出口的再见",
    excerpt: "结局播出后，网上吵翻了天。这句「没说出口的再见」到底是遗憾还是圆满？我们从台词、分镜与伏笔三个角度逐帧拆解。",
    category: "结局考据",
    tag: "深度解析",
    date: "2026-08-12",
    readTime: "10 分钟",
    likes: 987,
    image: "https://readdy.ai/api/search-image?query=Stylized%20editorial%20manga%20illustration%20of%20an%20open%20notebook%20with%20a%20blank%20page%20under%20warm%20amber%20lamp%20light%20beside%20a%20sleeping%20orange%20cat%2C%20warm%20vermilion%20and%20cream%20ink%20palette%20with%20halftone%20dots%2C%20vintage%20comic%20panel%2C%20contemplative%20bittersweet%20mood%2C%20high%20detail&width=900&height=600&seq=art-ending&orientation=landscape",
  },
  {
    id: "foreshadow",
    title: "三处容易被忽略的伏笔",
    excerpt: "回头看才发现，结局早在中段就写好了。这三处伏笔藏得极深，不放大分镜根本注意不到。",
    category: "伏笔盘点",
    tag: "考据",
    date: "2026-08-15",
    readTime: "7 分钟",
    likes: 446,
    image: "https://readdy.ai/api/search-image?query=Stylized%20editorial%20manga%20illustration%20of%20a%20detective-style%20close-up%20of%20a%20desk%20map%20with%20red%20string%20and%20sticky%20notes%2C%20warm%20vermilion%20and%20cream%20ink%20palette%20with%20halftone%20dots%2C%20vintage%20comic%20panel%2C%20curious%20analytical%20mood%2C%20high%20detail&width=900&height=600&seq=art-foreshadow&orientation=landscape",
  },
  {
    id: "hexiu-hidden",
    title: "嘿咻猫咪的隐藏设定：它才是全剧灵魂？",
    excerpt: "从不开口的嘿咻猫咪，为什么能成为读者心中的「灵魂角色」？它的每一次出现，似乎都踩在剧情的关键节点上。",
    category: "人物档案",
    tag: "隐藏设定",
    date: "2026-08-16",
    readTime: "5 分钟",
    likes: 733,
    image: "https://readdy.ai/api/search-image?query=Stylized%20editorial%20manga%20illustration%20of%20an%20orange%20cat%20sitting%20regally%20on%20a%20stack%20of%20old%20books%20by%20a%20warm%20window%2C%20warm%20vermilion%20and%20amber%20ink%20palette%20with%20halftone%20dots%2C%20vintage%20comic%20panel%2C%20mysterious%20yet%20cozy%20mood%2C%20high%20detail&width=900&height=600&seq=art-hexiu&orientation=landscape",
  },
  {
    id: "side-characters",
    title: "配角盘点：让故事更完整的小人物",
    excerpt: "除了主角团，那些只在两三话里出现的路人甲乙丙，其实共同撑起了这个温暖的世界观。",
    category: "人物档案",
    tag: "盘点",
    date: "2026-08-17",
    readTime: "6 分钟",
    likes: 291,
    image: "https://readdy.ai/api/search-image?query=Stylized%20editorial%20manga%20illustration%20of%20a%20bustling%20small%20neighborhood%20market%20street%20with%20diverse%20anonymous%20townspeople%20in%20background%2C%20warm%20vermilion%20and%20cream%20ink%20palette%20with%20halftone%20dots%2C%20vintage%20comic%20panel%2C%20lively%20communal%20mood%2C%20high%20detail&width=900&height=600&seq=art-side&orientation=landscape",
  },
];